/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS43MzI5NSAzTDYuOTIwNDUgMTMuNDQ4OUg2TDguODEyNSAzSDkuNzMyOTVaIiBmaWxsPSJpbmhlcml0Ii8+PC9zdmc+";